<template>
  <div class="wrap">
    <div class="publicTitle">
      您的当前位置：{{
      $route.query.t1 +
      ($route.query.t2
      ? "&lt;" + $route.query.t2
      : detailData.title
      ? "&lt;" + detailData.title
      : "")
      }}
    </div>
    <h2 class="detail-title">{{ detailData.title }}</h2>
    <video
      :src="detailData.newName"
      controls
      height="600"
      wight="800"
      autoplay
      style="margin-top:40px;"
      v-show=" detailData.newName !='https://www.myqmxx.cn/file/videofile/null' && detailData.newName !=''
        && detailData.newName !='https://www.myqmxx.cn/file/videofile/' && detailData.newName !='https://www.myqmxx.cn/file/videofile/' "
    ></video>
    <div class="titleTwo">
      <span class="time">
        {{
        detailData.creaTime && detailData.creaTime.time | dateFormat
        }}
      </span>
      <span class="view">
        浏览数：{{
        detailData.popularity ? detailData.popularity : 0
        }}
      </span>
    </div>
    <div class="content weui-article" v-html="detailData.description" @click="imageChange($event)"></div>
    <div class="download" v-if="detailData.annex != undefined && detailData.annex.length!=0">
      附件【
      <a
        @click="add()"
        download
        :href="'http://www.myqmxx.cn/baize_miyun_management_system/information/download?id='+detailData.id"
      >{{detailData.annex}}</a>】
      <span>已下载{{num}}次</span>
    </div>
    <div class="imgDolg" v-show="imgPreview.show" @click.stop="preview()">
      <img :src="imgPreview.img" />
    </div>
  </div>
</template>

<script>
export default {
  name: "artDetail",

  data() {
    return {
      detailData: [],
      num: 0,
      imgPreview: {
        show: false,
        img: ""
      }
    };
  },
  created() {
    //资讯详情
    this.getDetail(this.$route.query.id);
  },
  mounted() {},
  methods: {
    imageChange(e) {
      if (e.target.tagName == "IMG") {
        this.imgPreview.img = e.target.src;
        this.imgPreview.show = true;
      }
    },
    preview() {
      this.imgPreview.show = false;
    },
    add() {
      this.num = parseInt(this.num);
      this.num += 1;
      //				alert(this.num)
    },
    getDetail(id) {
      this.$ajax({
        method: "post",
        url: "homePage/getInformationById",
        data: {
          id: id
        },
        success: res => {
          if (res.code == 200) {

            this.detailData = res.message;
            this.num = this.detailData.loadNumber;
            // this.num = this.num;
          }
        },
        error: res => {
          console.log(res);
        }
      });

    }
  }
};
</script>

<style scoped="scoped" lang="scss">
.wrap {
  width: 1000px;
  margin: 0 auto;
  overflow: hidden;
  min-height: 500px;
}

.publicTitle {
  margin: 5px 0;
  color: #999;
  font-size: 16px;
}

.detail-title {
  font-size: 30px;
  color: #000;
  padding: 10px 0;
}

.titleTwo {
  color: #666;
  padding-bottom: 40px;

  .view {
    padding-left: 30px;
  }
}

.content {
  min-height: 500px;
}
.imgDolg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 1);
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: scroll;
}
img {
  width: 86%;
  height: auto;
  overflow: scroll;
  position: absolute;
  top: 0;
}
#imgDolgClose {
  position: fixed;
  top: 20px;
  cursor: pointer;
  right: 10px;
  font-size: 50px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/public/articalDetail.vue